import { Modal, useModal } from "~/components";
import UnlimitedOfferContent from "~/components/unlimited-offer-content";

// Minimal curiosity teaser for the chat-screen header icon row: a small CSS
// gift box (black + red ribbon/bow, matching the offer creative) + an amber
// attention dot, with a "Bonus" label on desktop (hidden on mobile). Built in
// CSS — no image asset. Opens the reward popup; the header only renders it for
// eligible users with no active window.
export default function UnlimitedBonusTeaser() {
  const offerModal = useModal();

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={offerModal.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            offerModal.open();
          }
        }}
        aria-label="See your unlocked bonus"
        className="flex flex-col items-center cursor-pointer hover:scale-105 transform transition-transform duration-300"
      >
        {/* -translate-y-[6px] compensates a consistent ~6px offset in this
            column: neighbor icons render ~6px higher than a centered icon here
            (same value that aligned the earlier sparkle). Shifts gift + dot together. */}
        <div className="relative flex h-9 items-center justify-center -translate-y-[6px]">
          {/* CSS gift box — black box, red ribbon + bow. The BOX (the heavy
              visual mass) is vertically centered on the row's centerline so it
              lines up with the neighbor icons; the bow rests on its top edge. */}
          <div className="relative h-9 w-8" aria-hidden>
            {/* bow — sits on the box's top edge */}
            <div className="absolute left-1/2 top-[2px] z-10 flex -translate-x-1/2 gap-[1px]">
              <span className="h-[7px] w-[6px] -rotate-[20deg] rounded-full bg-gradient-to-br from-red-400 to-red-600" />
              <span className="h-[7px] w-[6px] rotate-[20deg] rounded-full bg-gradient-to-bl from-red-400 to-red-600" />
            </div>
            {/* box + vertical ribbon, centered on the row line */}
            <div className="absolute inset-x-0 top-1/2 h-[22px] -translate-y-1/2 overflow-hidden rounded-[4px]
                            bg-gradient-to-b from-neutral-700 via-neutral-900 to-black
                            ring-1 ring-red-500/40 shadow-[0_0_8px_rgba(255,40,40,0.45)]">
              <span className="absolute inset-y-0 left-1/2 w-[5px] -translate-x-1/2 bg-gradient-to-b from-red-500 to-red-700" />
            </div>
          </div>
          {/* attention dot — anchored to the box's top-right */}
          <span className="absolute right-1 top-1.5 h-2 w-2 rounded-full bg-amber-400 ring-2 ring-headerBackground animate-pulse" />
        </div>
        <span className="hidden md:block text-text text-[0.5rem] -mt-0.5 font-semibold">
          Bonus
        </span>
      </div>

      <Modal {...offerModal.modalProps} subtleClose>
        <UnlimitedOfferContent />
      </Modal>
    </>
  );
}
